<div class="flex justify-between text-xl">
    <div class="flex items-center">
        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:user'"/>
        <h1 class="ml-2 font-semibold">
            User Profile
        </h1>
    </div>
    <tms-close-button btnClass="-mr-3" (click)="vm.close()" />
</div>
<div class="w-full mt-3 border-t"></div>

@if (vm.hasError()) {
    <tms-alert
        [type]="'error'"
        [title]="vm.errorTitle()"
        [detail]="vm.error().detail"
        [errors]="vm.error().errors"
        [class]="'mb-4'">
    </tms-alert>
}
<mat-dialog-content class="max-h-full px-0 py-4">
    <form [formGroup]="vm.userForm">
        <div class="grid w-full gap-6 sm:grid-cols-4">
            <div class="sm:col-span-2">
                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                    <mat-label>First Name</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:user'" matPrefix></mat-icon>
                    <input formControlName="firstName" matInput>
                    @if (vm.userForm.get('firstName')?.hasError('required')) {
                        <mat-error>First name is required</mat-error>
                    }
                    @if (vm.userForm.get('firstName')?.hasError('maxlength')) {
                        <mat-error>First name cannot exceed 50 characters</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="sm:col-span-2">
                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                    <mat-label>Surname</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:user'" matPrefix></mat-icon>
                    <input formControlName="surname" matInput>
                    @if (vm.userForm.get('surname')?.hasError('required')) {
                        <mat-error>Surname is required</mat-error>
                    }
                    @if (vm.userForm.get('surname')?.hasError('maxlength')) {
                        <mat-error>Surname cannot exceed 50 characters</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="sm:col-span-4">
                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                    <mat-label>Email</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:envelope'" matPrefix></mat-icon>
                    <input formControlName="email" matInput type="email">
                    <mat-hint>Contact an owner to change your email address</mat-hint>
                </mat-form-field>
            </div>
            <div class="sm:col-span-2">
                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                    <mat-label>Phone Number</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:phone'" matPrefix></mat-icon>
                    <input formControlName="phoneNumber" matInput>
                    @if (vm.userForm.get('phoneNumber')?.hasError('maxlength')) {
                        <mat-error>Phone number cannot exceed 256 characters</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="sm:col-span-2">
                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                    <mat-label>Position</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:briefcase'" matPrefix></mat-icon>
                    <input formControlName="position" matInput>
                    @if (vm.userForm.get('position')?.hasError('maxlength')) {
                        <mat-error>Position cannot exceed 50 characters</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="sm:col-span-4">
                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                    <mat-label>Current Password</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:lock-closed'" matPrefix></mat-icon>
                    <input formControlName="currentPassword" matInput type="password">
                    @if (vm.userForm.get('currentPassword')?.hasError('required')) {
                        <mat-error>Current password is required</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="sm:col-span-2">
                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                    <mat-label>New Password</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:lock-closed'" matPrefix></mat-icon>
                    <input formControlName="newPassword" matInput type="password">
                    @if (vm.userForm.get('newPassword')?.hasError('minlength')) {
                        <mat-error>Password must be at least 8 characters</mat-error>
                    }
                    @if (vm.userForm.get('newPassword')?.hasError('maxlength')) {
                        <mat-error>Password cannot exceed 50 characters</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="sm:col-span-2">
                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                    <mat-label>Confirm Password</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:lock-closed'" matPrefix></mat-icon>
                    <input formControlName="confirmPassword" matInput type="password">
                    @if (vm.userForm.get('confirmPassword')?.hasError('required')) {
                        <mat-error>Please confirm your password</mat-error>
                    }
                    @if (vm.userForm.get('confirmPassword')?.hasError('passwordMismatch')) {
                        <mat-error>Passwords do not match</mat-error>
                    }
                </mat-form-field>
            </div>
            @if (vm.hasMfaEnabledWritePermission()) {
                <div class="sm:col-span-4">
                    <mat-checkbox formControlName="mfaEnabled" class="mt-2" color="primary">
                        <span class="ml-2">Multi-Factor Authentication</span>
                    </mat-checkbox>
                </div>
            }
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-between px-0 mt-auto">
    <div class="w-full mb-4 border-t"></div>
    <tms-button
        [class]="'btn-outline'"
        (click)="vm.close()">
        Close
    </tms-button>
    <tms-button
        [class]="'btn-primary'"
        [isDisabled]="vm.isUpdating()"
        (click)="vm.save()">
        Save
    </tms-button>
</mat-dialog-actions>
